import React from "react";
import KiranImg from "../../assets/Mehak.png"; 
import RaviImg from "../../assets/Banner.webp";
import AkshayImg from "../../assets/Yogit.png";
import bg from "../../assets/_wocs_bg.webp";

const testimonials = [
  {
    imgage: KiranImg,
    name: "Mehak Aggarwal",
    role: "General Store Owner",
    text: "With recurring orders, I just set it once and forget. Milk and grocery reach my retail partners every morning without fail. Packky(powered by Chaafo) has become a daily part of how I run my business.",
  },
  {
    imgage: RaviImg,
    name: "Ravi Mishra",
    role: "Distribution Manager, GroFast",
    text: "Packky (powered by Chaafo) helped us scale our FMCG delivery across 12 stores without hiring our own fleet. The platform gave us complete control over logistics, and we now manage more deliveries with less operational overhead.",
  },
  {
    imgage: AkshayImg,
    name: "Yogit Aggarwal",
    role: "Logistics Head, B2B Pharma",
    text: "The dashboard helps us manage vendors and track all shipments in one place. It’s made our pharma deliveries more transparent and saved hours of coordination.",
  },
];

const ClientReviews = () => {
  return (
<div
  className="w-full py-12 bg-cover bg-center"
  style={{
    backgroundImage: `url(${bg})`,
  }}
>
  <div className="mx-auto max-w-7xl px-4">
    
   <h2 className="mb-2 text-center font-bold text-[#1d1d1d] text-[22px] md:text-[28px] lg:text-[28px]">
  What Our Clients Say
</h2>

   <p className="mb-4 text-center text-[14px] sm:text-[15px] md:text-[16px] lg:text-[18px] leading-6 text-gray-500 font-sf">
      From small stores to growing enterprises, our clients share their experience.
    </p>

    <div className="mt-5 pt-2 flex flex-wrap justify-center -mx-2 font-sf">
      {testimonials.map((client, index) => (
        <div
          key={index}
          className="w-full px-2 mb-4 md:w-1/2 lg:w-1/3 flex"
        >
          <div
            className="w-full p-4 shadow-sm  text-[#212529]"
            style={{
              borderRadius: "16px",
              background: "rgba(255, 255, 255, 0.45)",
              border: "1px solid white",
            }}
          >
            <div className="flex items-center mb-3">
              <img
                src={client.imgage}
                alt={client.name}
                width="50"
                height="50"
                className="rounded-full mr-3 object-cover aspect-square"
              />
              <div>
                <h6 className="mb-0 font-bold">{client.name}</h6>
                <small className="text-gray-500">{client.role}</small>
              </div>
            </div>

           <p className="text-[14px] sm:text-[15px] md:text-[16px] font-normal text-gray-900 leading-6 font-sf">
              “{client.text}”
            </p>
          </div>
        </div>
      ))}
    </div>

  </div>
</div>

     );
};

export default ClientReviews;